import React from 'react'
import '../Theme.css';
import './Text.css';

function Text({style, text}) {
    const className = "Text " + style;
    return (
        <p className={className}>{text}</p>
    )
}

export default Text;
